import { Redirect, useParams } from 'react-router-dom';

// Old URLs (/contact, /pricing) are not part of the new site: send them to the specialist form.
const ToSpecialist = () => {
  const { language } = useParams();
  return <Redirect to={`/${language}/specialist`} />;
};

export default ToSpecialist;
